import {
  BUTTON_PAY_ORDER,
  BUTTON_PAY_ANTI,
  BUTTON_PAY_ANTI_ERROR,
  BUTTON_PAY_PAY_SUCCESS,
  BUTTON_PAY_CHECK_ID_SUCCESS,
} from '../constants/buttonpay';

export const setOrderInfo = payload => ({
  type: BUTTON_PAY_ORDER,
  payload,
});

export const setAntiInfo = payload => ({
  type: BUTTON_PAY_ANTI,
  payload,
});

export const setAntiErr = payload => ({
  type: BUTTON_PAY_ANTI_ERROR,
  payload,
});

export const setPayCheckIdSuc = payload => ({
  type: BUTTON_PAY_CHECK_ID_SUCCESS,
  payload,
});

export const setPayPaySuc = payload => ({
  type: BUTTON_PAY_PAY_SUCCESS,
  payload,
});
